import { initialState, State, Action } from '../store/store';

export const setProjectId = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    projectId: data as any,
  };

  return nextState;
};
